import PropTypes from "prop-types";
import { KeyStatsContainer } from "./KeyStats.styles";
import { getCleanLabel, roundOff } from "utils";

const KeyStats = ({ stats, showTitle }) => {
  const keys = Object.keys(stats || {});
  return (
    <KeyStatsContainer>
      <div className="key-statistics-container">
        {showTitle && <h3 className="mb-3">Key Statistics</h3>}
        {!keys.length && (
          <p className="no-stats-data">No Key Statistics found</p>
        )}
        {keys.length > 0 && (
          <ul>
            {keys.map((key, i) => {
              const label = getCleanLabel(key);
              return (
                key && (
                  <li key={i}>
                    <span className="key text-ellipsis" title={label}>
                      {label}
                    </span>
                    <span className="stats">
                      {stats[key] && typeof stats[key] !== "string"
                        ? roundOff(stats[key])
                        : stats[key]}
                    </span>
                  </li>
                )
              );
            })}
          </ul>
        )}
      </div>
    </KeyStatsContainer>
  );
};

export default KeyStats;

KeyStats.propTypes = {
  stats: PropTypes.object,
  showTitle: PropTypes.bool,
};

KeyStats.defaultProps = {
  stats: {},
  showTitle: true,
};
